import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=74051520&scoped=true&"
import script from "./customerDetail.vue?vue&type=script&lang=js&"
export * from "./customerDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./customerDetail.vue?vue&type=style&index=1&id=74051520&scoped=true&lang=scss&"
import style2 from "./customerDetail.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74051520",
  null
  
)

export default component.exports